if (window.location.pathname.match('/chat')) {
  window.firebaseConfig = {
    authDomain: `tunag-${process.env.RAILS_ENV}.firebaseapp.com`,
    databaseURL: `https://tunag-${process.env.RAILS_ENV}.firebaseio.com`,
    projectId: `tunag-${process.env.RAILS_ENV}`,
  };

  if (process.env.RAILS_ENV === 'production') {
    window.firebaseConfig.apiKey = "AIzaSyBzsZWkWGeOfITNm1Z8vRnFY4FP2UGzUO0";
  } else if (process.env.RAILS_ENV === 'staging') {
    window.firebaseConfig.apiKey = "AIzaSyCeNHxJOmoHU1mxh5UulzMluNJxm1deHy4";
  } else {
    window.firebaseConfig.apiKey = "AIzaSyBUycg9rI6BhUh-CTEulCtaUVEW1rZ4kvw";
  }
}
